export const TEXT_CONSTANTS = {
  BACK: 'Back',
  GENERATE_INVOICE: 'Generate Invoice',
  REFUND_PAYMENT: 'Refund Payment',
  INVOICE_PREVIEW: 'Invoice Preview',
  SAVE_INVOICE: 'Save Invoice',
  PATIENT_DETAILS: 'Patient details',
  NAME: 'Name',
  ADDRESS: 'Address',
  POST_CODE: 'Post code',
  DATE_OF_BIRTH: 'Date of birth',
  MEMBERSHIP_NUMBER: 'Membership number',
  AUTHORIZATION_CODE: 'Authorization code',
  INVOICE_DETAILS: 'Invoice details',
  INVOICE_DATE: 'Invoice date',
  CONSULTANT: 'Consultant',
  ITEMS_TO_BILL: 'Items to bill',
  ITEM_DESCRIPTION: 'Item description',
  PROCEDURE_PRICE: 'Procedure price',
  CONSULTANT_REQUIRED:
    'Consultant selection is required for invoice generation',
};
